import { EventEmitter } from '../../includes/eventEmitter';
import { Injectable } from '@angular/core';
import { CrudApiProvider } from '../crud-api/crud-api';
import { ToolsProvider } from '../tools/tools';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as moment from 'moment';

@Injectable()
export class AdsProvider extends EventEmitter {
  log = debug('app:AdsProvider');

  initedListeners = false;
  ads: any = [];
  adPromise;

  // will be inited by function
  nativeFeedIds = [];
  nativeBannerIds = [];

  nativeQueue = [];
  loadingNativeAds: any = {};
  loadedNativeAds: any = {};

  constructor(public crudApi: CrudApiProvider, public tools: ToolsProvider) {
    super();

    this.log('constructed');

    this.initIds();

    // No longer load on boot ... it's kinda deprecated,
    // but technically they can
    // still try it in the admin panel
    // this.loadAds();

    this.tools.on('viewWillEnter', () => {
      this.hideBanner();
    });
  }

  initIds() {
    if (/(android)/i.test(navigator.userAgent)) {
      // android ones
      this.nativeFeedIds = [
        '1005129406233936_1905466002866934',
        '1005129406233936_1905993542814180',
        '1005129406233936_1905993612814173',
      ];
      this.nativeBannerIds = [
        '1005129406233936_1905993669480834',
        '1005129406233936_1905993782814156',
        '1005129406233936_1905993886147479',
      ];
    } else {
      // iOS ones
      this.nativeFeedIds = [
        '1005129406233936_1905463569533844',
        '1005129406233936_1905905846156283',
        '1005129406233936_1905915286155339',
      ];
      this.nativeBannerIds = [
        '1005129406233936_1905967476150120',
        '1005129406233936_1905969449483256',
        '1005129406233936_1905969562816578',
      ];
    }

    /*
    // these are for testing ... saving them here in case we need to retest
    if (/(android)/i.test(navigator.userAgent)) {
      // android ones
      this.nativeFeedIds = [
        'IMG_16_9_APP_INSTALL#1005129406233936_1905466002866934',
        'VID_HD_9_16_39S_LINK#1005129406233936_1905993542814180',
        'VID_HD_16_9_15S_LINK#1005129406233936_1905993612814173',
      ];
      this.nativeBannerIds = [
        'IMG_16_9_APP_INSTALL#1005129406233936_1905993669480834',
        'IMG_16_9_APP_INSTALL#1005129406233936_1905993782814156',
        'IMG_16_9_APP_INSTALL#1005129406233936_1905993886147479',
      ];
    } else {
      // iOS ones
      this.nativeFeedIds = [
        'IMG_16_9_APP_INSTALL#1005129406233936_1905463569533844',
        'VID_HD_9_16_39S_LINK#1005129406233936_1905905846156283',
        'VID_HD_16_9_15S_LINK#1005129406233936_1905915286155339',
      ];
      this.nativeBannerIds = [
        'IMG_16_9_APP_INSTALL#1005129406233936_1905967476150120',
        'IMG_16_9_APP_INSTALL#1005129406233936_1905969449483256',
        'IMG_16_9_APP_INSTALL#1005129406233936_1905969562816578',
      ];
    }*/
  }

  initListeners() {
    if (this.initedListeners) {
      return;
    }

    this.initIds();

    this.initedListeners = true;

    this.log('initing');
    document.addEventListener('onAdFailLoad', e => {
      const data = <any>e;
      this.log('AD FAIL', data);
      if (data.adType === 'native') {
        this.loadingNativeAds[data.adId] = false;
        this.loadedNativeAds[data.adId] = data;
        this.emit(`fail-nativeAd-${data.adId}`, data);
      }
    });
    document.addEventListener('onAdLoaded', e => {
      const data = <any>e;
      this.log('AD LOADED', data);
      if (data.adType === 'native') {
        this.loadedNativeAds[data.adId] = data;
        this.loadingNativeAds[data.adId] = false;
        this.emit(`success-nativeAd-${data.adId}`, data);
      }
    });
    document.addEventListener('onAdPresent', e => {
      this.log('AD PRESENT');
    });
    document.addEventListener('onAdLeaveApp', e => {
      this.log('AD LEAVE');
    });
    document.addEventListener('onAdDismiss', e => {
      this.log('AD DISMISS');
    });
  }

  loadAds() {
    if (this.ads.length) {
      return Promise.resolve(this.ads);
    }

    this.log('loading ads');

    return (this.adPromise = this.crudApi
      .get('/api/posts', {
        limit: 50,
        postType: 'AD',
      })
      .then(res => {
        return (this.ads = res.data);
      }));
  }

  removeAdsSeenPastSixHours(ads) {
    this.log('removing ads seen past the last six hours');

    let adsSeen;
    try {
      adsSeen = JSON.parse(localStorage.getItem('CDLLIFE_AD_IMPRESSIONS'));
    } catch (e) {
      adsSeen = [];
    }

    adsSeen = _.filter(adsSeen, d => {
      return new Date(d.timestamp) > moment().subtract(6, 'hours').toDate();
    });

    const ids = _.keyBy(adsSeen, 'adId');

    return _.filter(ads, a => {
      return !ids[a._id];
    });
  }
  hideBanner() {}
}



// WEBPACK FOOTER //
// ./src/providers/ads/ads.ts